import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
    BackNextButton,
    AddButton,
    Modal,
    EditCard,
    Button,
} from "../../../../../common";
import { EditCardItems } from "../EditCardItems";
import { ReactComponent as Pen } from "../../../../../../assets/images/companyIcons/pen.svg";
import { ReactComponent as Designation } from "../../../../../../assets/images/companyIcons/CompanyProfile/designation.svg";
import { ReactComponent as EmailIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/email.svg";
import { ReactComponent as NameIcon } from "../../../../../../assets/images/companyIcons/CompanyProfile/name.svg";
import { useDeleteCategoryMutation, useGetCategoryListMutation } from "../../../../../../store/Company/companyApiSlice";
import { ReactComponent as Delete } from "../../../../../../assets/images/companyIcons/delete1.svg"
import { ReactComponent as Verified } from "../../../../../../assets/icons/verified.svg";
import { ReactComponent as Declined } from "../../../../../../assets/icons/cancel.svg";
import { ReactComponent as Requested } from "../../../../../../assets/icons/pending.svg";
import { ReactComponent as Skipped } from "../../../../../../assets/icons/review.svg";
import { AddTaxInformation } from "./AddTaxInformation";
import { CommonToast } from "../../../../../common/Toast";
import { ReactComponent as Spinner } from "../../../../../../assets/icons/spinner.svg";

export const TaxCategoryDetails = ({ onPrev, onNext, onSkip, compRefetch }) => {
    const { currentEditingCompany } = useSelector((state) => state.company);
    const { token } = useSelector((state) => state.auth);
    const [companyCategoryList, setCategoryList] = useState([]);
    const [editCategory, setEditCategory] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [deleteCategory] = useDeleteCategoryMutation();
    const [dataChanged, setDataChanged] = useState(false);

    const [getCategoryList, { isLoading: categoryListLoading }] = useGetCategoryListMutation();

    const refetchCategoryList = async () => {
        const res = await getCategoryList({
            id: currentEditingCompany?.companyID,
            token,
        })
        setCategoryList(res?.data)
    }

    useEffect(() => {
        (async () => {
            const res = await getCategoryList({
                id: currentEditingCompany?.companyID,
                token,
            })
            if (res?.data?.length > 0) {
                setCategoryList(res?.data)
            }
        })()
    }, [])

    const modalHandleDelete = async (deleteInfo) => {
        let dataval = await deleteCategory({
            data: {
                tax_id: deleteInfo?.tax_id,
                company_id: currentEditingCompany?.companyID,
            },
            token,
        });
        if (dataval) {
            CommonToast.success("Tax Category Deleted Successfully");
            refetchCategoryList();
            compRefetch();
            setDataChanged(!dataChanged);
        }
    }

    const modalHandle = (category) => {
        setEditCategory(category);
        setIsOpen(!isOpen);
        setDataChanged(!dataChanged);
    };
    function createArrayFromObject(object) {
        let otherData = [
            "tax_reg_no",
            "tax_category_title",
            "upload_file",
        ];
        let icons = {
            tax_reg_no: <Designation />,
            tax_category_title: <NameIcon />,
            upload_file: <EmailIcon />,
        };

        let data = [];

        for (let key in object) {
            if (otherData.includes(key)) {
                data.push({ [key]: object[key], icon: icons[key] });
            }
        }

        let keyValuePairs = data.map((item) =>
            Object.entries(item).map(([key, value]) => [key, value])
        );
        let html = keyValuePairs.map((item) => (
            <EditCardItems
                heading={item[0][0] === "upload_file" ? "Supporting Document" : item[0][0] === "tax_reg_no" ? "Tax Number" : item[0][0] === "tax_category_title" ? "Category" : item[0][0]?.replaceAll("_", " ")}
                subHeading={item[0][0] === "upload_file" ? <a className="underline underline-offset-4" href={item[0][1]} target="_blank" rel="noopener noreferrer">View Document</a> : item[0][1]?.replace("|", "")}
                icon={item[1][1]}
            />
        ));
        return html;
    }

    return (
        <div className="mt-5 mr-20">
            {isOpen && (
                <Modal modalHandle={modalHandle}>
                    <AddTaxInformation
                        editCategory={editCategory}
                        modalHandle={modalHandle}
                        refetch={refetchCategoryList}
                        compRefetch={compRefetch}
                        dataChanged={dataChanged}
                        setDataChanged={setDataChanged}
                    />
                </Modal>
            )}
            <h3 className="text-f20 font-semibold text-secondarytwo text-left mb-2">
                Tax Information
            </h3>

            <div className="border border-slate rounded-lg p-8 mb-6">
                <AddButton
                    text="Add New Tax Information"
                    buttonText="Add Tax Information"
                    onClick={() => modalHandle(null)}
                />
                {categoryListLoading ? <div className="flex justify-center items-center h-full w-full text-[20px] font-bold text-secondary gap-2"><Spinner /> Loading Data</div> : <div className="grid grid-cols-2 gap-4">
                    {companyCategoryList?.length > 0 && companyCategoryList?.map((item, index) => (
                        <EditCard>
                            <div className="statusSection">
                                {item.status === "Verified" && (
                                    <Verified />
                                )}
                                {item.status === "Declined" && (
                                    <Declined />
                                )}
                                {item.status === "Skipped" && (
                                    <Skipped />
                                )}
                                {(item.status === "Requested" || item.status === "raised" || item.status === "pending") && (
                                    <Requested />
                                )}
                            </div>
                            <div className="h-[18rem] overflow-y-auto relative  my-2">
                                {createArrayFromObject(item)}
                            </div>
                            {<div className="actionseditDelete  gap-4">

                                <Button
                                    onClick={() => modalHandle(item)}
                                    classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                                >
                                    <span>Edit Details</span>
                                    <span>
                                        <Pen />
                                    </span>
                                </Button>
                                <Button
                                    onClick={() => modalHandleDelete(item)}
                                    classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                                >
                                    <span>Delete</span>
                                    <span>
                                        <Delete />
                                    </span>
                                </Button>
                            </div>
                            }
                        </EditCard>
                    ))}
                </div>}
            </div>

            <BackNextButton
                onPrev={() => onPrev(2, "License Information", "Details")}
                onNext={() => onNext(3, "Ownership Structure", "Details")}
                onSkip={() => onSkip(3, "Ownership Structure", "Details")}
            />
        </div>
    );
};
